// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORM_IS_DIRTY_ARE_YOU_SURE_YOU_WANT_TO_LEAVE = "Ur\u010dite chce\u0161 od\u00eds\u0165? Pr\u00edde\u0161 o neulo\u017een\u00e9 zmeny.";
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1r sa nepodarilo odosla\u0165. Niekde v \u0148om m\u00e1\u0161 chybu.";
